import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getCategoriesRequest, getCategoriesRequestError, getCategoriesRequestSuccess } from "../../slices/Content/GetCategoriesSlice";

export const GetCategoriesApi = (page, limit, status, search) => async (dispatch) => {
    const queryParams = new URLSearchParams({
        page: page,
        limit: limit,
        status: status,
        search: search
    }).toString();

    const urlWithParams = `${endpoints.getContentCategories}?${queryParams}`;

    try {
        dispatch(getCategoriesRequest());
        axiosInstance({
            method: "GET",
            url: urlWithParams,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getCategoriesRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getCategoriesRequestError(_error));
            });
    } catch (error) { }
};
